import { Component } from '@angular/core';
import { Const } from '../../helpers/Const';
import { SwaService } from '../../../service/services/misc/swa/swa.service';
import {NavigationService} from "../../../service/services/misc/navigation/navigation.service";
import {Utils} from "../../helpers/Utils";

@Component({
    selector: 'app-support-dialog',
    templateUrl: './support-dialog.component.html',
    styleUrls: ['./support-dialog.component.scss'],
    standalone: false
})
export class SupportDialogComponent {
    const = Const;
    constructor(private _swaService: SwaService, private _navigationService: NavigationService) {}

    onClickSupportLink() {
        this._swaService.sendEvent(this._swaService.SWA_EVENT_TYPES.SUPPORT_LINK_CLICKED);
    }

    goToTeams() {
        this._navigationService.openInNewTab(Const.TEAMS_URL);
    }

    protected readonly Utils = Utils;
}
